import type { NextPage, GetServerSideProps } from 'next'

import Page from '@/components/pages/project/item'

import SEO from '@/modules/seo'
import {ProjectModel, ProjectExtraModel} from '@/modules/project'
import type { Item, PreparationForm, Draft, OpinionDocument, MainProposal, EnvironmentalConservation, EnvironmentalImpactDocument } from '@/modules/project'


export const getServerSideProps: GetServerSideProps = async (context) => {
  const idx = parseInt((context.params && context.params.idx || context.query && context.query.idx) as string, 10);
  const model = new ProjectModel();
  const extraModel = new ProjectExtraModel();
  const result = await model.getItem({ idx });

  const preparationFormResult = await extraModel.getItem({idx: idx, type: "preparation-form"});
  const projectDraftResult = await extraModel.getItem({idx: idx, type: "draft"});
  const opinionDocumentResult = await extraModel.getItem({idx: idx, type: "opinion"});
  const mainProposalResult = await extraModel.getItems({idx: idx, type: "proposal"});
  const environmentConservationResult = await extraModel.getItems({idx: idx, type: "environment"});
  const environmentalImpactResult = await extraModel.getItem({idx: idx, type: "environmental-impact"});

  return {
    props: {
      item: result.item,
      preparationFormItem: preparationFormResult.item,
      projectDraftItem: projectDraftResult.item,
      opinionDocumentItem: opinionDocumentResult.item,
      mainProposalItem: mainProposalResult.items,
      environmentConservationItem: environmentConservationResult.items,
      environmentalImpactItem: environmentalImpactResult.item
    }
  }
}


interface IProps {
  item: Item
  preparationFormItem: PreparationForm
  projectDraftItem: Draft
  opinionDocumentItem: OpinionDocument
  mainProposalItem: MainProposal[]
  environmentConservationItem: EnvironmentalConservation[]
  environmentalImpactItem: EnvironmentalImpactDocument
}

const Component: NextPage<IProps> = (props) => {
  const pageTitle = `평가정보조회`

  return (
    <div className='flex flex-col justify-center'>
      <SEO title={pageTitle} />
      <Page {...props} />
    </div>
  )
}

export default Component
